import { css } from "@emotion/css";

import { grey, yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createRateInputStyles = ({ spacing }: Theme) => {
  return {
    root: css({
      display: "flex",
    }),
    starIcon: css({
      width: 33,
      height: 33,
      color: grey[300],
    }),
    active: css({
      color: yellow[400],
    }),
    starButton: css({
      outline: "none",
      border: "none",
      background: "none",
      padding: spacing([0, 0.5]),
    }),
  };
};
